import { http } from '@/utils'

export const getCity = (): Promise<any> => http.get('/hrm/region/', {})
